
import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import Vditor from "vditor"
import "vditor/dist/index.css"
import { Message } from '@/plugin/message/index';


@Component({
  components: {
  },
})

export default class myVditor extends Vue {
  @Prop({
    required: true,
    default: '',
  }) content!: string;

  @Prop({
    required: true,
    default: '200px',
  }) height?: string;

  @Prop({
    default: '',
  }) placeholder!: string;


  private contentEditor: any = null;


  public $refs!:{
    editor: any;
  }

  mounted() {
    this.initVditor();
  }

  /**
   * 初始化 Markdown 编辑器及其本站静态资源路径。
   * 入参：无；返回值：无。
   */
  initVditor() {
    const auth = JSON.parse(window.sessionStorage.getItem('auth') as string);
    this.contentEditor = new Vditor("markdownContent",{
      // Vditor 会基于此路径加载语言包、Lute、图标和预览所需资源。
      cdn: `${process.env.BASE_URL}vendor/vditor`,
      height: this.height,
      toolbarConfig: {
        pin: true,
      },
      preview: {
        math: {
          inlineDigit: true,
        },
        actions: [],
      },
      upload: {
        accept: 'image/jpg, image/jpeg, image/png',
        url: `${process.env.VUE_APP_HOST}/common/rich/file`,
        fieldName: 'file',
        filename(name) {
          return name.replace(/[^(a-zA-Z0-9\u4e00-\u9fa5\.)]/g, "")
            .replace(/[\?\\/:|<>\*\[\]\(\)\$%\{\}@~]/g, "")
            .replace("/\\s/g", "");
        },
        headers: {
          'Authorization': auth.token || ''
        },
        format(files, res) {
          let resultData = JSON.parse(res)
          let fileInfo = {}
          fileInfo[resultData.name] = 'https:' + resultData.path
          return JSON.stringify({
            msg: '',
            code: 200,
            data: {
              succMap: fileInfo
            }
          })
        },
        error(msg) {
          Message.error("上传失败了：" + msg)
        },
      },
      cache: {
        enable: false,
      },
      input: (value: string) => {
        this.$emit('input', value);
      },
      after: () => {
        let textValue = ''
        if (this.content && this.content !== 'null') {
          textValue = this.content
        }
        this.contentEditor.setValue(textValue)
      },
    });
  }

  getMarkdownValue() {
    return this.contentEditor.getValue();
  }

  @Watch('content', { immediate: true })
  getContent(v: string) {
    // 只有当编辑器已初始化且内容确实发生变化时才更新，避免光标位置丢失
    if (this.contentEditor) {
      const currentValue = this.contentEditor.getValue();
      if (currentValue !== v) {
        this.contentEditor.setValue(v || '');
      }
    }
  }
}
